module.exports = __webpack_public_path__ + "static/githyanki_kithrak-b38e9ab504e7a4bf94c83ebe03fe7bdc.png";